export type OperatingSystem = 'Windows' | 'Mac' | 'Linux' | 'Unknown'

export function getOperatingSystem(): OperatingSystem {
    const { userAgent } = window.navigator

    const userAgentLower = userAgent.toLowerCase()

    if (userAgentLower.includes('windows')) {
        return 'Windows'
    } else if (userAgentLower.includes('mac')) {
        return 'Mac'
    } else if (userAgentLower.includes('linux')) {
        return 'Linux'
    } else {
        return 'Unknown'
    }
}
